/**
 =========================================================
 * Material Dashboard 2 React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// Material Dashboard 2 React base styles
import colors from "../../base/colors";

// Material Dashboard 2 React helper functions
import pxToRem from "../../functions/pxToRem";
import boxShadow from "../../functions/boxShadow";

const {white} = colors;

const stepIcon = {
    styleOverrides: {
        root: {
            background: "white",
            fill: "white",
            // stroke: "#9fc9ff",
            strokeWidth: pxToRem(10),
            width: pxToRem(40),
            height: pxToRem(40),
            borderRadius: "50%",
            border:"1.3px black solid",
            zIndex: 99,
            transition: "all 200ms linear",

     
            "&.Mui-active": {
                background: "#005CB1",
                fill: "#005CB1",
                 // stroke: white.main,
                borderColor: white.main,
                // boxShadow: boxShadow([0, 0], [0, 2], white.main, 1),
                
            },
          
          
        },
        text: {
            fill: "black",
            fontSize: pxToRem(14),
            fontWeight: "bold",
            textAlign: "center",
            lineHeight: 1.5,
        },
    },
};

export default stepIcon;
